import React from "react";
import {
  Button,
  Transition,
  Grid,
  Form,
  Header,
  Message
} from "semantic-ui-react";
import GooglePlaceAutoComplete from "../../google-place-autocomplete/GooglePlaceAutoComplete";
import { connect } from "react-redux";
import classNames from "classnames";
import { googleTracking } from "../../../util";
import { fetchBuildingByPlaceId } from "../../../store/actions/building-by-place";
import {
  setConnection,
  checkCompatibility
} from "../../../store/actions/connection";

class AddYourAddress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation,
      errors: {},
      checked: false,
      located: null,
      built: null,
      isSubmitting: false,
      serverError: null
    };
    this.continuePress = false;
    this.handleLocatedChange = this.handleLocatedChange.bind(this);
    this.handleBuiltChange = this.handleBuiltChange.bind(this);
    this.resetErrors = this.resetErrors.bind(this);
  }
  handleLocatedChange(e, target) {
    this.setState({ located: target.checked });

    if (target.checked && this.state.errors && this.state.errors.located) {
      this.resetErrors("located");
    }
  }
  handleBuiltChange(e, target) {
    this.setState({ built: target.checked });

    if (target.checked && this.state.errors && this.state.errors.built) {
      this.resetErrors("built");
    }
  }

  resetErrors(field) {
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [field]: null
      }
    }));
  }

  continue() {
    const { changeStep } = this.props;
    const errors = {};
    const { address, fetchBuildingByPlaceId, placeId } = this.props;

    this.continuePress = true;
    if (!address) {
      errors["address"] = "Please enter address";
    }

    // if (!this.state.located) {
    //   errors['located'] = 'Building must be located in Toronto, Ottawa or GTA';
    // }

    // if (!this.state.built) {
    //   errors['built'] = 'Building must be built after 2000 and have over 100 units';
    // }
    this.setState({ errors: errors });

    if (Object.keys(errors).length) {
      return errors;
    }

    this.setState({ isSubmitting: true, serverError: null });
    this.props.setConnection({ fromPage: "request-fibrestream" });
    fetchBuildingByPlaceId(placeId)
      .then(response => {
        response.fromPage = "request-fibrestream";
        this.props.setConnection(response);

        this.setState({ isSubmitting: false });
        this.setState({
          animation: "fade right",
          visible: false
        });

        const result_type = response.result_type;

        if (result_type === 1) {
          setTimeout(() => {
            changeStep(10, "fade left");
          }, 400);
        } else if (result_type === 2) {
          setTimeout(() => {
            changeStep(11, "fade left");
          }, 400);
        } else if (result_type === 3) {
          setTimeout(() => {
            changeStep(7, "fade left");
          }, 400);
        } else if (result_type === 4) {
          setTimeout(() => {
            changeStep(8, "fade left");
          }, 400);
        }
      }, error => {
        if (error.response.status === 404) {
          setTimeout(() => {
            changeStep(12, "fade left");
          }, 400);
        }
      })

  }

  componentDidMount() {
    this.setState({
      visible: true
    });
    googleTracking({
      event: "virtualPageview",
      pageview: "/unavailable&compatible/step2/request-fibrestream-type-address"
    });
  }

  render() {
    const {
      visible,
      animation,
      errors,
      isSubmitting,
      serverError
    } = this.state;
    const { address } = this.props;
    return (
      <div>
        <Transition visible={visible} duration={500} animation={animation}>
          <div className="building-form">
            <Header className="title__main" as="h1" textAlign="center">
              Request FibreStream
            </Header>
            <Header.Subheader className="text-black">
              You can request FibreStream if your building is compatible.
            </Header.Subheader>
            <Form className="form check-address">
              <Form.Group className="mx-0 add-address">
                <Form.Field
                  className={classNames(
                    {
                      "is-error": Object.keys(errors).length && errors.address
                    },
                    "mx-0"
                  )}
                >
                  <GooglePlaceAutoComplete
                    resetErrors={this.resetErrors}
                    inputprops={{
                      placeholder: "Type your building address",
                      defaultValue: address
                    }}
                    error={errors.address}
                  />
                </Form.Field>
              </Form.Group>

              {/* <Form.Checkbox label='My building is located in Toronto, Ottawa or the GTA' value='located' onChange={this.handleLocatedChange} />
            <Form.Checkbox className="checkbox__last" label='My building was built after 2000 and has over 100 units' value='built' onChange={this.handleBuiltChange}  /> */}
              {errors.located && (
                <Message error visible>
                  <Header as="h5" textAlign="center">
                    {errors.located}
                  </Header>
                </Message>
              )}

              {errors.built && (
                <Message error visible>
                  <Header as="h5" textAlign="center">
                    {errors.built}
                  </Header>
                </Message>
              )}
              <Grid className="mx-0 my-0">
                <Button
                  className="btn--full mt-0"
                  type="button"
                  size="medium"
                  disabled={isSubmitting}
                  onClick={this.continue.bind(this)}
                >
                  Next
                </Button>
              </Grid>
              {serverError && (
                <Message error visible>
                  <Header as="h5" textAlign="center">
                    {serverError}
                  </Header>
                </Message>
              )}
            </Form>
            {/* <Grid className="mt-0">
              <Grid.Row className="px-4 py-0 learn-more__text">
                <Grid.Column textAlign="center">
                  <p className="itc-std-md f-size--14">
                    If your building does not meet the above criteria then
                    unfortunately it is not compatible with our service.
                  </p>
                </Grid.Column>
              </Grid.Row>
            </Grid> */}
          </div>
        </Transition>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    address: state.connection.address,
    placeId: state.connection.placeId
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchBuildingByPlaceId: data => dispatch(fetchBuildingByPlaceId(data)),
    setConnection: data => dispatch(setConnection(data)),
    checkCompatibility: data => dispatch(checkCompatibility(data))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddYourAddress);



// WEBPACK FOOTER //
// ./src/components/check-availability/service-not-available/AddYourAddress.js